import React from 'react';
import Util from '../Util';
import Storage from '../Storage';
import $ from 'jquery';

class SheldonFileBrowser extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      filepath: '',
      content: '',
      retrievedAt: null,
      custom: false,
      showLineNumber: true,
      lines: 1000,
      fromLine: -1,
    };
  }

  componentWillUnmount() {
    this.unmounted = true;
  }

  handleOnChangeCustom(event) {
    this.setState({
      custom: event.target.checked,
    });
  }

  handleOnChangeShowLineNumber(event) {
    this.setState({
      showLineNumber: event.target.checked,
    });
  }

  handleOnChangeFromLine(event) {
    this.setState({
      fromLine: event.target.value,
    });
  }

  handleOnChangeLines(event) {
    this.setState({
      lines: event.target.value,
    });
  }

  handleRetrieveAllLines() {
    this.setState({
      lines: -1,
    });
  }

  handleRetrieveFromStartOfFile() {
    this.setState({
      fromLine: 1,
    });
  }

  handleRetrieveFromEndOfFile() {
    this.setState({
      fromLine: -1,
    });
  }

  handleCustomLoadClick(checkCache, event) {
    event.preventDefault();
    this.handleButtonClick(this.state.filepath, checkCache);
  }

  handleButtonClick(filepath, checkCache = true) {
    let hostInfo = this.props.hostInfo;
    let { ip, macAddress } = this.props.hostInfo;
    let { showLineNumber, fromLine, lines } = this.state;

    if (this.unmounted) return;

    if (hostInfo.isVPNKskType && !Util.isValidIpAddress(ip)) {
      this.setState({
        content: <span style={{ color: 'red' }}>Invalid ip: {ip}</span>,
      });
      return;
    }

    let contentKey = `file:content:${ip}:${macAddress}:${filepath}:${fromLine}:${lines}`;
    let retrievedAtKey = `file:retrieved:${ip}:${macAddress}:${filepath}:${fromLine}:${lines}`;

    if (checkCache) {
      let cachedContent = Storage.getSessionText(contentKey);
      let cachedRetrievedAt = new Date(Storage.getSessionText(retrievedAtKey));
      if (cachedContent) {
        this.setFileContent(filepath, cachedContent, cachedRetrievedAt);
        return;
      }
    }

    if (this.inProgress) {
      this.setState({
        filepath: filepath,
        retrievedAt: null,
        content: (
          <div>
            <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
            <div>Request in Progress!</div>
          </div>
        ),
      });
      return; // stop when other request in progress
    }

    this.setState({
      filepath: filepath,
      retrievedAt: null,
      content: <i className='fa fa-spinner fa-spin fa-3x fa-fw' />,
    });

    this.inProgress = true;

    // implemented /getfile endpoint in linuxdash only after v1.2.17
    // let useLinuxDash = ! /^v1\.2\.1[0-7]$/.test(linuxdashVer);

    // implemented new /getfile endpoint in linuxdash v1.2.22 onward
    // let useNewLinuxDashGetFile = ! /^v1\.2\.1[0-9]$/.test(linuxdashVer) && !/^v1\.2\.2[0-1]$/.test(linuxdashVer);

    let url = getFileUrl(hostInfo, filepath, fromLine, lines, showLineNumber);

    $.ajax({ url: url, dataType: 'text' })
      .always(() => {
        this.inProgress = false;
      })
      .done((data) => {
        let retrievedAt = new Date();
        this.setFileContent(filepath, data, retrievedAt);
        if (data) {
          let mb = data.length / (1024 * 1024);
          if (mb < 1) {
            Storage.setSessionItem(contentKey, data);
            Storage.setSessionItem(retrievedAtKey, retrievedAt.toISOString());
          }
        }
      })
      .fail((jqXHR) => {
        this.setState({
          content: <span style={{ color: 'red' }}>{jqXHR.responseText}</span>,
        });
      });
  }

  setFileContent(filepath, content, retrievedAt) {
    if (/^{"status":"err","msg":"Not logged on"}/.test(content)) {
      content = 'Failed to retrieve file: ' + filepath;
    }

    this.setState(
      {
        filepath: filepath,
        content: content,
        retrievedAt: retrievedAt,
      },
      () => {
        let $content = $(this.refs.content);
        $content.scrollTop($content[0].scrollHeight); // scroll to bottom
      }
    );
  }

  handleDownloadClick(hostInfo, filepath, retrievedAt, content) {
    let { ip, macAddress, kioskName } = hostInfo;
    if (content) {
      let parts = filepath.split('/');
      let fileName = parts[parts.length - 1];
      let dateStr = Util.localDateString(retrievedAt);
      let dlName = `${ip}-${kioskName}-${macAddress}-${dateStr}-${fileName}`;
      // console.log('content.length:', content.length)
      Util.download(content, dlName, 'text/plain');
    }
  }

  render() {
    let { hostInfo, panelHeight } = this.props;
    let { filepath, content, retrievedAt, custom, showLineNumber, fromLine, lines } = this.state;
    let fileUrl = getFileUrl(hostInfo, filepath, fromLine, lines, showLineNumber);

    let validRetrievedAt = retrievedAt && retrievedAt instanceof Date;
    let contentLength = content.length;
    if (contentLength > 1024 * 1024) {
      contentLength = `${parseInt(contentLength / (1024 * 1024))}MB`;
    } else if (contentLength > 1024) {
      contentLength = `${parseInt(contentLength / 1024)}KB`;
    }

    return (
      <div className='sheldon-content-wrapper'>
        <h2>{filepath ? filepath : 'File Browser'}</h2>
        Retrieve file and save to browser cache - only if the size is smaller than 1MB to prevent
        browser's unresponsiveness.
        <div style={{ margin: '10px 0' }}>
          <span style={{ margin: '0 5px' }}>
            <input type='checkbox' value={custom} onChange={this.handleOnChangeCustom.bind(this)} />{' '}
            Custom file path?
          </span>
          <span style={{ margin: '0 5px' }}>
            <input
              type='checkbox'
              value={showLineNumber}
              checked={showLineNumber}
              onChange={this.handleOnChangeShowLineNumber.bind(this)}
            />{' '}
            Show line number?
          </span>
          <span style={{ margin: '0 5px' }}>
            From line number:{' '}
            <input
              type='text'
              size='10'
              value={fromLine}
              onChange={this.handleOnChangeFromLine.bind(this)}
            />
          </span>
          <span style={{ margin: '0 5px' }}>
            # of lines:{' '}
            <input
              type='text'
              size='10'
              value={lines}
              onChange={this.handleOnChangeLines.bind(this)}
            />
          </span>
          <span style={{ margin: '0 5px' }}>
            <button
              className='pure-input-1-5 pure-button pure-button-primary'
              onClick={this.handleRetrieveFromStartOfFile.bind(this, true)}
            >
              from start of file?
            </button>
          </span>
          <span style={{ margin: '0 10px' }}>
            <button
              className='pure-input-1-5 pure-button pure-button-primary'
              onClick={this.handleRetrieveFromEndOfFile.bind(this, true)}
            >
              from end of file?
            </button>
          </span>
          <span style={{ margin: '0 10px' }}>
            <button
              className='pure-input-1-5 pure-button pure-button-primary'
              onClick={this.handleRetrieveAllLines.bind(this, true)}
            >
              all lines?
            </button>
          </span>
        </div>
        {custom ? (
          <form className='pure-form' autoComplete='on' style={{ height: 58 }}>
            <fieldset>
              <input
                className='pure-input-2-3'
                style={{ marginRight: 5 }}
                autoComplete='on'
                autoFocus={true}
                type='text'
                name='filepath'
                placeholder='/path/to/file'
                value={filepath}
                onChange={(event) => this.setState({ filepath: event.target.value })}
              />
              <button
                className='pure-input-1-5 pure-button pure-button-primary'
                type='submit'
                onClick={this.handleCustomLoadClick.bind(this, true)}
              >
                Retrieve
              </button>
            </fieldset>
          </form>
        ) : (
          <div className='sheldon-buttons' style={{ height: 58 }}>
            <div style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '10px' }}>
              <button
                className={
                  filepath == '/home/administrator/Provisioner.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/home/administrator/Provisioner.log')}
              >
                Provisioner.log
              </button>
              <button
                className={
                  filepath == '/usr/local/kskapi/kskapi.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/kskapi/kskapi.log')}
              >
                kskapi.log
              </button>
              <button
                className={
                  filepath == '/usr/local/payapi/payapi.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/payapi/payapi.log')}
              >
                payapi.log
              </button>
              <button
                className={
                  filepath == '/usr/local/printapi/printapi.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/printapi/printapi.log')}
              >
                printapi.log
              </button>
              <button
                className={
                  filepath == '/usr/local/heatwave/heatwave.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/heatwave/heatwave.log')}
              >
                heatwave.log
              </button>
              <button
                className={
                  filepath == '/usr/local/linuxdash/linuxdash.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/linuxdash/linuxdash.log')}
              >
                linuxdash.log
              </button>
              <button
                className={
                  filepath == '/usr/local/baitapi/baitapi.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/baitapi/baitapi.log')}
              >
                baitapi.log
              </button>
              <button
                className={
                  filepath == '/usr/local/cafeapi/logs/cafeapi.out'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/cafeapi/logs/cafeapi.out')}
              >
                cafeapi.out
              </button>
              <button
                className={
                  filepath == '/home/administrator/probe-config.json'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/home/administrator/probe-config.json')}
              >
                probe-config.json
              </button>
              <button
                className={
                  filepath == '/usr/local/rts/data/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/rts/data/')}
              >
                data/
              </button>
              <button
                className={
                  filepath == '/home/administrator/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/home/administrator/')}
              >
                ~/
              </button>
              <button
                className={
                  filepath == '/home/administrator/Desktop'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/home/administrator/Desktop')}
              >
                ~/Desktop
              </button>
              <button
                className={
                  filepath == '/home/administrator/.config/autostart'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/home/administrator/.config/autostart')}
              >
                ~/.config/autostart
              </button>
              <button
                className={
                  filepath == '/var/log/install-team-viewer.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/install-team-viewer.log')}
              >
                install-team-viewer.log
              </button>
              <button
                className={
                  filepath == '/usr/local/capui/capui.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/capui/capui.log')}
              >
                capui.log
              </button>
              <button
                className={
                  filepath == '/home/administrator/.pm2/logs/capui-out-0.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(
                  this,
                  '/home/administrator/.pm2/logs/capui-out-0.log'
                )}
              >
                capui-out-0.log
              </button>
              <button
                className={
                  filepath == '/home/administrator/.pm2/logs/capui-error-0.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(
                  this,
                  '/home/administrator/.pm2/logs/capui-error-0.log'
                )}
              >
                capui-error-0.log
              </button>
              <button
                className={
                  filepath == '/home/administrator/probe-log.txt'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/home/administrator/probe-log.txt')}
              >
                probe-log.txt
              </button>
              <button
                className={
                  filepath == '/usr/local/rts/kiosk-updater/logs/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/rts/kiosk-updater/logs/')}
              >
                kiosk-updater/logs/
              </button>
              <button
                className={
                  filepath == '/usr/local/kskapi/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/kskapi/')}
              >
                kskapi/
              </button>
              <button
                className={
                  filepath == '/usr/local/kskapi/logs/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/kskapi/logs/')}
              >
                kskapi/logs/
              </button>
              <button
                className={
                  filepath == '/usr/local/payapi/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/payapi/')}
              >
                payapi/
              </button>
              <button
                className={
                  filepath == '/usr/local/payapi/logs/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/payapi/logs/')}
              >
                payapi/logs/
              </button>
              <button
                className={
                  filepath == '/usr/local/cafeapi/logs/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/cafeapi/logs/')}
              >
                cafeapi/logs/
              </button>

              <button
                className={
                  filepath == '/usr/local/printapi/'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/usr/local/printapi/')}
              >
                printapi/
              </button>
              <button
                className={
                  filepath == '/var/log/syslog'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/syslog')}
              >
                syslog (Ubuntu)
              </button>
              <button
                className={
                  filepath == '/var/log/messages'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/messages')}
              >
                messages (CentOS)
              </button>
              <button
                className={
                  filepath == '/var/log/cron' ? 'pure-button pure-button__selected' : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/cron')}
              >
                cron (CentOS)
              </button>
              <button
                className={
                  filepath == '/var/log/dmesg' ? 'pure-button pure-button__selected' : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/dmesg')}
              >
                dmesg
              </button>
              <button
                className={
                  filepath == '/var/log/boot.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/boot.log')}
              >
                boot.log
              </button>
              <button
                className={
                  filepath == '/var/log/Xorg.0.log'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/var/log/Xorg.0.log')}
              >
                Xorg.0.log
              </button>
              <button
                className={
                  filepath == '/etc/hosts' ? 'pure-button pure-button__selected' : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/etc/hosts')}
              >
                hosts
              </button>
              <button
                className={
                  filepath == '/etc/resolv.conf'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/etc/resolv.conf')}
              >
                resolv.conf
              </button>
              <button
                className={
                  filepath == '/etc/default/grub'
                    ? 'pure-button pure-button__selected'
                    : 'pure-button'
                }
                onClick={this.handleButtonClick.bind(this, '/etc/default/grub')}
              >
                grub
              </button>
            </div>
          </div>
        )}
        <div className='sheldon-content'>
          <div className='pure-u-1-2' style={{ textAlign: 'left' }}>
            {validRetrievedAt && (
              <span style={{ paddingRight: '10px' }}>
                Retrieved at: {retrievedAt.toLocaleString()}
              </span>
            )}
            {validRetrievedAt && (
              <span style={{ paddingRight: '10px' }}>({Util.xUnitsOfTimeAgo(retrievedAt)})</span>
            )}
          </div>
          <div className='pure-u-1-2' style={{ textAlign: 'right' }}>
            {filepath && !this.inProgress ? (
              <a
                href='javascript:void(0)'
                style={{ paddingRight: '10px' }}
                onClick={this.handleButtonClick.bind(this, filepath, false)}
              >
                Retrieve again
              </a>
            ) : null}
          </div>
          <pre
            style={{
              border: '1px solid #ddd',
              height: panelHeight - 340,
              overflow: 'auto',
              padding: '5px',
            }}
            ref='content'
          >
            {content}
          </pre>
          <div className='pure-u-1-2'>
            {contentLength ? (
              <span style={{ paddingRight: '10px' }}>Size: {contentLength}</span>
            ) : null}
            {contentLength ? (
              <span style={{ paddingRight: '10px' }}>
                Number of lines: {content.split(/\r\n|\r|\n/).length}
              </span>
            ) : null}
          </div>
          <div className='pure-u-1-2' style={{ textAlign: 'right' }}>
            {contentLength ? (
              <a href={fileUrl} target='_blank' style={{ marginRight: 10 }}>
                <i className='fa fa-fw fa-external-link' />
                Open in new window
              </a>
            ) : null}
            {contentLength ? (
              <a
                href='javascript:void(0)'
                onClick={this.handleDownloadClick.bind(
                  this,
                  hostInfo,
                  filepath,
                  retrievedAt,
                  content
                )}
              >
                <i className='fa fa-fw fa-cloud-download' />
                Download
              </a>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

function getFileUrl(hostInfo, filepath, fromLine, lines, showLineNumber) {
  let baseUrl =
    location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
  let path =
    Util.getLinuxDashPath(hostInfo) +
    `/getfile?file=${filepath}&fromline=${fromLine}&lines=${lines}&showlinenum=${showLineNumber}`;
  return baseUrl + path;
}

export default SheldonFileBrowser;



// WEBPACK FOOTER //
// ./src/components/SheldonFileBrowser.js